import { azureFetch } from "./azureFetch";

export const fetchSensorDetails = async (id) => {
    try {
        const response = await azureFetch('sensor', { id: id });
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};

export const fetchSensorInfo = async (id) => {
    try {
        const response = await azureFetch('sensor/details', { id: id });
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};

export const fetchExpressions = async (path, requestBody) => {
    try {
        const response = await azureFetch(path, requestBody);
        return response;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};


export const fetchSensorCRAgg = async (requestBody) => {
    try {
        const response = await azureFetch('SensorCorrosionRateAggregation', requestBody);
        return response;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};

export const fetchTC = async (path, requestBody) => {
    try {
        const response = await azureFetch(path, requestBody);
        return response;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};

export const getWhatIfAnalysisFetchFeatures = async (requestBody) => {
    try {
        const response = await azureFetch('WhatIfAnalysisFetchFeatures', requestBody);
        return response;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};


export const getLatestPCRDate = async (requestBody) => {
    try {
        const response = await azureFetch('GetLatestPCRDate', requestBody);
        return response;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};



export const getWhatIfAnalysisPrediction = async (requestBody) => {
    try {
        const response = await azureFetch('WhatIfAnalysisPrediction', requestBody);
        return response;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};

export const fetchMissingData = async (id) => {
    try {
        const response = await azureFetch('missing-data', { subject: id });
        return response.data;
    } catch (error) {
        console.error("Error fetching missing data:", error);
        throw error;
    }
};

export const calculateWTLoss = async (requestBody) => {
    try {
        
        const response = await azureFetch('WTLoss', requestBody);
        return response;
    } catch (error) {
        console.error("Error fetching missing data:", error);
        throw error;
    }
};


export const calculateForecastWT = async (requestBody) => {
    try {

        const response = await azureFetch('CalculateForecastWT', requestBody);
        return response;
    } catch (error) {
        console.error("Error fetching missing data:", error);
        throw error;
    }
};


export const forecastWTExpression = async (requestBody) => {
    try {
        const response = await azureFetch('ForecastWTExpression', requestBody);
        return response;
    } catch (error) {
        console.error("Error fetching missing data:", error);
        throw error;
    }
};

export const fetchSensorAlert = async (sensor, start_date, end_date) => {
    try {
        const response = await azureFetch('fetch-alert-details', { sensor, start_date, end_date });
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor alert:", error);
        throw error;
    }
};

export const updateRating = async (sensor, rating, rating_comment) => {
    try {
        const response = await azureFetch('updateRating', { sensor, rating, rating_comment });
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor alert:", error);
        throw error;
    }
};

